import { styled } from '@mui/material/styles';
import { Box, Card, Button } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(3),
  gap: theme.spacing(3),
  backgroundColor: '#f9fafb',
  minHeight: '100vh',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  border: '1px solid #e0e0e0',
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',

  '&:hover': {
    boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.12)',
    borderColor: '#1e40af',
  },

  '.product-avatar': {
    width: 96,
    height: 96,
    borderRadius: theme.shape.borderRadius,
    objectFit: 'cover',
    border: '2px solid #e0e0e0',
    marginBottom: theme.spacing(1.5),
    cursor: 'pointer',
  },
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
}));

// Primary (blue) action button
export const PrimaryButton = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 8,
  padding: theme.spacing(1, 3),
  fontSize: '0.95rem',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  backgroundColor: '#1e40af',
  color: '#fff',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    backgroundColor: '#2563eb',
    transform: 'translateY(-1px)',
    boxShadow: '0px 5px 12px rgba(0,0,0,0.2)',
  },
}));

// Danger (red) action button
export const DangerButton = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 8,
  padding: theme.spacing(1, 3),
  fontSize: '0.95rem',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  backgroundColor: '#dc2626', // Tailwind red-600 style
  color: '#fff',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    backgroundColor: '#b91c1c', // darker red on hover
    transform: 'translateY(-1px)',
    boxShadow: '0px 5px 12px rgba(0,0,0,0.2)',
  },
}));
